import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import commonSlice from './services/controllers/common/CommonSlice';
import authSlice from './services/controllers/auth/AuthSlice';
import userSlice from './services/controllers/user/UserSlice';
import warehouseSlice from './services/controllers/warehouse/WarehouseSlice';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['common', 'warehouse', 'user'],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    common: commonSlice,
    auth: authSlice,
    user: userSlice,
    warehouse: warehouseSlice,
  }),
);

const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
